import { render } from "./HsTableShell.vue?vue&type=template&id=b0016582&scoped=true"
import script from "./HsTableShell.vue?vue&type=script&lang=js"
export * from "./HsTableShell.vue?vue&type=script&lang=js"

import "./HsTableShell.vue?vue&type=style&index=0&id=b0016582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0016582"]])

export default __exports__